import axiosInstance from './api.config';

export const newsAPI = {
  // Список новостей
  getAll: (params = {}) => axiosInstance.get('/news/', { params }),
  
  // Детали новости
  getBySlug: (slug) => axiosInstance.get(`/news/${slug}/`),
  
  // Категории
  getCategories: () => axiosInstance.get('/news/categories/'),
  getCategoryBySlug: (slug) => axiosInstance.get(`/news/categories/${slug}/`),
  getCategoryNews: (slug, params = {}) => axiosInstance.get(`/news/categories/${slug}/news/`, { params }),
  createCategory: (data) => axiosInstance.post('/news/categories/', data),
  updateCategory: (slug, data) => axiosInstance.put(`/news/categories/${slug}/`, data),
  deleteCategory: (slug) => axiosInstance.delete(`/news/categories/${slug}/`),
  
  // Избранные и срочные
  getFeatured: () => axiosInstance.get('/news/featured/'),
  getBreaking: () => axiosInstance.get('/news/breaking/'),
  
  // Комментарии
  getComments: (slug) => axiosInstance.get(`/news/${slug}/comments/`),
  createComment: (data) => axiosInstance.post('/news/comments/', data),
  updateComment: (id, data) => axiosInstance.put(`/news/comments/${id}/`, data),
  deleteComment: (id) => axiosInstance.delete(`/news/comments/${id}/`),
  
  // Лайки
  like: (slug) => axiosInstance.post(`/news/${slug}/like/`),
  unlike: (slug) => axiosInstance.delete(`/news/${slug}/unlike/`),
  
  // Админ функции
  create: (data) => axiosInstance.post('/news/', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update: (slug, data) => axiosInstance.put(`/news/${slug}/`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  delete: (slug) => axiosInstance.delete(`/news/${slug}/`),
};
